import React from 'react';
import { Typography, Box, Autocomplete, TextField, Grid } from '@mui/material';
import VoiceTextField from '../../../../components/VoiceTextField';
import { diseaseOptions, riskFactorOptions, complicationsOptions } from '../constants/options';

const RiskAssessmentSection = ({ formData, handleChange, setFormData, errors }) => {
  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Condition & Risk Assessment
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={diseaseOptions}
            value={formData.primary_disease || ''}
            onChange={(e, val) => setFormData(prev => ({ ...prev, primary_disease: val }))}
            renderInput={(params) => (
              <VoiceTextField
                {...params}
                name="primary_disease"
                label={<span>Primary Disease <span style={{ color: 'red' }}>*</span></span>}
                fullWidth
                error={!!errors.primary_disease}
                helperText={errors.primary_disease || "🎙️ Click mic to speak primary disease"}
                onVoiceTranscript={(text) => setFormData(prev => ({ ...prev, primary_disease: text }))}
                onChange={handleChange}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
            1. Associated Risk Factor:
          </Typography>
          <Autocomplete
            freeSolo
            options={riskFactorOptions}
            value={formData.associated_risk_factor || ''}
            onChange={(e, val) => setFormData(prev => ({ ...prev, associated_risk_factor: val }))}
            renderInput={(params) => (
              <TextField
                {...params}
                name="associated_risk_factor"
                label={<span>Associated Risk Factor <span style={{ color: 'red' }}>*</span></span>}
                fullWidth
                error={!!errors.associated_risk_factor}
                helperText={errors.associated_risk_factor}
                onChange={handleChange}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
            2. Complications:
          </Typography>
          <Autocomplete
            freeSolo
            options={complicationsOptions}
            value={formData.complications || ''}
            onChange={(e, val) => setFormData(prev => ({ ...prev, complications: val }))}
            renderInput={(params) => (
              <TextField
                {...params}
                name="complications"
                label={<span>Potential Complications <span style={{ color: 'red' }}>*</span></span>}
                fullWidth
                error={!!errors.complications}
                helperText={errors.complications}
                onChange={handleChange}
              />
            )}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, p: 2, bgcolor: '#f1f5f9', borderRadius: 2 }}>
        <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
          In view of the above, I have been explained the risks of not having the procedure and that the proposed surgery / procedure carries a higher risk than normal. 
          I have been informed that I might need intensive care treatment after the procedure.
          Having understood the above, I give my high-risk consent. I absolve Annai Arul Hospitals (P) Ltd., its doctor and the staff in the event of any complications.
        </Typography>
      </Box>
    </Box>
  );
};

export default RiskAssessmentSection;
